const isEthAddress = value => {
  return value.startsWith("0x") && value.length === 42;
};

const formatShortEthAddress = (ethAddress, num = 5) => {
  return `${ethAddress.substring(0, num)}...${ethAddress.substring(ethAddress.length - num, ethAddress.length)}`;
};

export { formatShortEthAddress, isEthAddress };
